import { App } from './App';
import { CreditCardUpdate } from './CreditCardUpdate';
import { Dashboard } from './Dashboard';
import { Login } from './Login';
import { Logout } from './Logout';
import { MealPlan } from './MealPlan';
import { MealPlanEdit } from './MealPlanEdit';
import { MealPlanBasic } from './MealPlanBasic';
import { Profile } from './Profile';
import { Recipe } from './Recipe';
import { ResetPassword } from './ResetPassword';
import { Reviews } from './Reviews';
import { ShoppingList } from './ShoppingList';
import { Signup } from './Signup';
import { Upgrade } from './Upgrade';
import { WelcomeSteps } from './WelcomeSteps';
import { Workout } from './Workout';
import { WorkoutPlayer } from './WorkoutPlayer';

import {
  Favourites,
  FavouritesRecipes,
  FavouritesVideos,
  FavouritesWorkouts,
} from './Favourites';

import {
  Nutrition,
  NutritionHack,
  NutritionHacks,
  NutritionMealPlans,
  NutritionMealPlan,
  NutritionRecipe,
  NutritionRecipes,
} from './Nutrition';

import {
  Program,
  ProgramGraduation,
  ProgramIntro,
  ProgramMealPlan,
  ProgramNav,
  ProgramRecipe,
  ProgramRedirect,
  ProgramWeek,
  ProgramWorkout,
} from './Program';

import {
  Workouts,
  workoutsHack,
  workoutsHacks,
  WorkoutsDetail,
  WorkoutsExpress,
  WorkoutsVideo,
  WorkoutsVideos,
} from './Workouts';

export const Containers = angular
  .module('App.Containers', [])
  .component('app', App)
  .component('creditCardUpdate', CreditCardUpdate)
  .component('dashboard', Dashboard)
  .component('favourites', Favourites)
  .component('favouritesRecipes', FavouritesRecipes)
  .component('favouritesVideos', FavouritesVideos)
  .component('favouritesWorkouts', FavouritesWorkouts)
  .component('login', Login)
  .component('logout', Logout)
  .component('mealPlan', MealPlan)
  .component('mealPlanEdit', MealPlanEdit)
  .component('mealPlanBasic', MealPlanBasic)
  .component('nutrition', Nutrition)
  .component('nutritionHack', NutritionHack)
  .component('nutritionHacks', NutritionHacks)
  .component('nutritionMealPlans', NutritionMealPlans)
  .component('nutritionMealPlan', NutritionMealPlan)
  .component('nutritionRecipe', NutritionRecipe)
  .component('nutritionRecipes', NutritionRecipes)
  .component('profile', Profile)
  .component('program', Program)
  .component('programGraduation', ProgramGraduation)
  .component('programIntro', ProgramIntro)
  .component('programMealPlan', ProgramMealPlan)
  .component('programNav', ProgramNav)
  .component('programRecipe', ProgramRecipe)
  .component('programRedirect', ProgramRedirect)
  .component('programWeek', ProgramWeek)
  .component('programWorkout', ProgramWorkout)
  .component('recipe', Recipe)
  .component('resetPassword', ResetPassword)
  .component('reviews', Reviews)
  .component('shoppingList', ShoppingList)
  .component('signup', Signup)
  .component('upgrade', Upgrade)
  .component('welcomeSteps', WelcomeSteps)
  .component('workout', Workout)
  .component('workoutPlayer', WorkoutPlayer)
  .component('workouts', Workouts)
  .component('workoutsHack', workoutsHack)
  .component('workoutsHacks', workoutsHacks)
  .component('workoutsExpress', WorkoutsExpress)
  .component('workoutsVideo', WorkoutsVideo)
  .component('workoutsVideos', WorkoutsVideos)
  .component('workoutsDetail', WorkoutsDetail).name;



// WEBPACK FOOTER //
// ./src/containers/index.js